import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-verify-reservation',
  templateUrl: './verify-reservation.component.html',
  styleUrls: ['./verify-reservation.component.scss']
})
export class VerifyReservationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<VerifyReservationComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    ) { }

    session: any;

  closeModal() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.session = this.modalData
  }
}
